import type { ENVType } from '@/types/ENV'

export default {
  APP_URL: 'https://rbac-qa.solaireresort.com/',

  // make sure to end url with a '/'
  API_URL: 'https://apik-qa.solaireresort.com/rbac/',
  MSAL_TENANT_ID: '9c1d6af6-94df-4a4c-9b70-26edaee05a21',
  MSAL_CLIENT_ID: 'b9d130f7-b524-454a-9523-8b95031294e4',
  MSAL_REDIRECT_URI: '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: '/',
  TOKEN_API_URL: 'https://apik-qa.solaireresort.com/rbac/api/v1.0/auth/oauth2/token',
  TOKEN_API_CLIENT_ID: '',
  TOKEN_API_CLIENT_SECRET: '',
  USE_KONG_API: true
} as ENVType
